import LightBulbIcon from './component'

export default LightBulbIcon
